import React, { useCallback } from 'react';
import { LinePath } from '@visx/shape';
import { curveMonotoneX } from '@visx/curve';

function ElementTrendLine({
  capabilityId,
  className,
  data,
  x,
  y,
  onMouseOver,
  onMouseOut,
  onClick,
}) {
  const handleTrendOver = useCallback(() => {
    onMouseOver(capabilityId);
  }, [onMouseOver, capabilityId]);

  const handleTrendClick = useCallback(() => {
    onClick(capabilityId);
  }, [onClick, capabilityId]);

  return (
    <g key={capabilityId} className={className}>
      <LinePath
        data={data}
        x={x}
        y={y}
        curve={curveMonotoneX}
        className="palette-stroke"
        onMouseOver={handleTrendOver}
        onMouseOut={onMouseOut}
        onClick={handleTrendClick}
      />
      {data.map((d, i) => (
        <circle
          key={i}
          cx={x(d)}
          cy={y(d)}
          r={2}
          className="palette-fill"
          style={{ pointerEvents: 'none', stroke: 'none' }}
        />
      ))}
    </g>
  );
}

export default ElementTrendLine;
